import React, { type FunctionComponent } from 'react'
import { type OrderStatus } from 'legacy/sections/orders/utils/orders.types'
import { OrdersListTabsItem } from 'legacy/sections/orders/components/list/components/tabs/components/OrdersListTabsItem'
import { OrdersListTabsFooter } from 'legacy/sections/orders/components/list/components/tabs/components/OrdersListTabsFooter'
import {
  type OrdersListApiOrderCounts,
  type OrdersListApiApproxGMV,
} from 'legacy/sections/orders/components/list/utils/ordersList.types'
import SubNav from 'legacy/components/Nav/SubNav'
import { SUBNAV_WIDTH } from 'legacy/common/theme'
import { type OrdersListBehaviour } from 'legacy/sections/orders/components/list/utils/ordersList.hooks'

const subNavStyle = { height: '100%', minWidth: SUBNAV_WIDTH }

interface Props extends OrdersListBehaviour {
  approxGmv: OrdersListApiApproxGMV | undefined
  orderCounts: OrdersListApiOrderCounts | undefined
}

const ORDER_STATUS_TABS: OrderStatus[] = [undefined, 'in_progress', 'completed', 'canceled']

export const OrdersListTabs: FunctionComponent<Props> = ({
  queryParamsBehaviour: { orderStatus, setOrderStatus },
  loading,
  approxGmv,
  orderCounts,
}) => {
  const renderedTabs = ORDER_STATUS_TABS.map(orderStatusTab => (
    <OrdersListTabsItem
      key={orderStatusTab || 'all'}
      loading={loading}
      approxGmv={approxGmv}
      orderCounts={orderCounts}
      orderStatus={orderStatusTab}
      setOrderStatus={setOrderStatus}
      isActive={orderStatus === orderStatusTab}
    />
  ))

  const renderedFooter = <OrdersListTabsFooter approxGmv={approxGmv} />

  return (
    <SubNav style={subNavStyle} footer={renderedFooter}>
      {renderedTabs}
    </SubNav>
  )
}
